export default () => {

  $('.js-mobile-filter').on('click', function() {
    $('.catalog__filter').addClass('active');
    $('.catalog__filter-box').addClass('active');
  })

  $('.js-close-mobile-filter').on('click', function () {
    $('.catalog__filter-box').removeClass('active');
    setTimeout(() => {
      $('.catalog__filter').removeClass('active');
    }, 300);
  })

  $('.js-search').on('click', function (event) {
    event.stopPropagation();
    $('.header__search-holder').toggleClass('active');
  });
  
  $(document).on("click touchend", (event) => {
    event.stopPropagation();
    if ($(event.target).closest(".header__search, .js-search").length) return;
    $(".header__search-holder").removeClass('active');
  });

  $('.js-basket').on('click', function (event) {
    event.stopPropagation();
    $('.header__basket').toggleClass('active');
  });
  $('.js-header-basket-close').on('click', function (event) {
    event.stopPropagation();
    $('.header__basket').removeClass('active');
  });
  $(document).on("click touchend", (event) => {
    event.stopPropagation();
    if ($(event.target).closest(".header__basket, .js-basket").length) return;
    $(".header__basket").removeClass('active');
  });

  $('.js-callback').on('click', function () {
    $('.popup--call').addClass('active');
  })

  $('.js-call-master').on('click', function() {
    $('.popup--master').addClass('active');
  })

  $('.js-director').on('click', function() {
    $('.popup--director').addClass('active');
  })

  $('.js-miscalculation').on('click', function () {
    $('.popup--miscalculation').addClass('active');
  })

  $('.js-close-popup').on('click', function () {
    $('.popup').removeClass('active');
  })

}


// WEBPACK FOOTER //
// app/scripts/components/popup.js